// polyfill voor oudere browsers
require('intersection-observer');

// Polyfill
if (window.NodeList && !NodeList.prototype.forEach) {
    NodeList.prototype.forEach = function (callback, thisArg) {
        thisArg = thisArg || window;
        for (var i = 0; i < this.length; i++) {
            callback.call(thisArg, this[i], i, this);
        }
    };
}

export function slideInTitles(titles) {
    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.intersectionRatio > 0) {
                entry.target.classList.add('animate');
                observer.unobserve(entry.target);
            }
        });
    });

    titles.forEach(image => observer.observe(image) );
}

export function moveOnScroll(titles) {
    window.addEventListener('scroll', () => {
        let distance = window.pageYOffset;
        titles.forEach((title, i) => {
            if(i === 0) {
                title.style.transform = `translateX(-${distance/10}px)`;
            } else {
                title.style.transform = `translateX(${distance/10}px)`;
            }
        });
    });
}